"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepTags = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ = require("../../..");

var _VideoPlayer = require("../../VideoPlayer");

var _PersonalizeControlsHeader = require("../PersonalizeControlsHeader");

var _PersonalizeControlsFooter = require("../PersonalizeControlsFooter");

var _StepController = require("../../../molecules/StepController");

var _TraceTagsToggler = require("../TraceTagsToggler");

var _TagEditor = require("../../TagEditor");

var _molecules = require("../../../molecules");

var _atoms = require("../../../atoms");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Step Tags
var StepTags = function StepTags(_ref) {
  var name = _ref.name,
      game = _ref.game,
      moment = _ref.moment,
      updates = _ref.updates,
      tagsType = _ref.tagsType,
      onNextStep = _ref.onNextStep,
      buttonTitle = _ref.buttonTitle,
      onCloseClick = _ref.onCloseClick,
      onPreviousStep = _ref.onPreviousStep,
      fullGameMoment = _ref.fullGameMoment,
      showContentInMobile = _ref.showContentInMobile,
      showPreviousButton = _ref.showPreviousButton;
  var sport = "soccer";

  if (moment) {
    sport = (0, _.getProperty)("sport_type", moment, "soccer");
  } else if (game) {
    sport = (0, _.getProperty)("sport_type", game, "soccer");
  } // this reducer might be resused in other components


  var _useReducer = (0, _react.useReducer)(function (state, action) {
    var next = JSON.parse(JSON.stringify(state));

    if (action.type === "set") {
      return JSON.parse(JSON.stringify(action.tags));
    }

    if (action.type === "toggle") {
      var _iterator = _createForOfIteratorHelper(next),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var tag = _step.value;

          if (tag.name === action.name) {
            tag.selected = tag.selected ? false : true; // toggle linked tags

            // toggle linked tags
            if (tag.selected && tag.editor && tag.editor.toggles) {
              var _iterator2 = _createForOfIteratorHelper(tag.editor.toggles),
                  _step2;

              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var toggle = _step2.value;

                  var _iterator3 = _createForOfIteratorHelper(next),
                      _step3;

                  try {
                    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                      var ot = _step3.value;

                      if (ot.name === toggle) {
                        ot.selected = !tag.selected;
                      }
                    }
                  } catch (err) {
                    _iterator3.e(err);
                  } finally {
                    _iterator3.f();
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            } // prevent toggle if required


            // prevent toggle if required
            if (!tag.selected && tag.editor && tag.editor.required) {
              tag.selected = true;
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    return next;
  }, updates.tags),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      tags = _useReducer2[0],
      dispatch = _useReducer2[1];

  (0, _react.useEffect)(function () {
    if (tags.length > 0) {
      return;
    }

    var editorTags = [];
    var sportTagType = "".concat(sport, "-").concat(tagsType);

    switch (sportTagType) {
      case "soccer-trace":
        editorTags = (0, _.getEditorTags)(sport, ["Attacking", "Defense", "Goalkeeping"]);
        break;

      case "baseball-trace":
        editorTags = (0, _.getEditorTags)(sport, ["Hitting", "Pitching", "Fielding"]);
        break;

      case "soccer-game":
        editorTags = (0, _.getEditorTags)(sport, ["Location", "Description", "Players"], game);
        break;

      case "baseball-game":
        editorTags = (0, _.getEditorTags)(sport, ["Description", "Players"], game);
        break;

      case "soccer-edit":
        editorTags = (0, _.getEditorTags)(sport, ["Location", "Description", "Players"], game);
        break;

      case "baseball-edit":
        editorTags = (0, _.getEditorTags)(sport, ["Description", "Players"], game);
        break;

      default:
        editorTags = (0, _.getEditorTags)(sport, ["Description", "Players"], game);
        break;
    } // add selected attribute to editor tags


    editorTags = (0, _.selectEditorTags)(editorTags, moment); // set tags

    dispatch({
      type: "set",
      tags: editorTags
    });
  }, [game, moment, tagsType]); // add spotlight to show in video

  var massagedFullGameMoment = fullGameMoment;

  if (updates.spotlightEnabled) {
    massagedFullGameMoment["spotlights"] = [{
      center: [updates.spotlightCenterX, updates.spotlightCenterY],
      corr: 0,
      height: 0,
      trace_number: "-1",
      utc: updates.spotlightStartAtUTC,
      width: 0
    }];
  } else {
    massagedFullGameMoment["spotlights"] = [];
  } // Get video container ref


  var videoPlayerContainerRef = (0, _VideoPlayer.useVideoContainerRef)();

  var handleCloseClick = function handleCloseClick() {
    onCloseClick({
      tags: tags
    });
  };

  var handlePreviousStepClick = function handlePreviousStepClick() {
    if (typeof onPreviousStep === "function") {
      onPreviousStep({
        tags: tags
      });
    }
  };

  var handleNextStepClick = function handleNextStepClick() {
    if (typeof onNextStep === "function") {
      onNextStep({
        tags: tags
      });
    }
  }; // Handle display of content in mobile


  var showContentInMobileClassName = !showContentInMobile ? "mobile-hide" : ""; // Video timing & spotlight logic

  var momentDuration = updates.stopAtRelative - updates.startAtRelative;
  return /*#__PURE__*/_react.default.createElement(_StepController.Step, {
    name: name
  }, /*#__PURE__*/_react.default.createElement(_atoms.Stack, {
    className: "personalize-preview-container",
    xs: _atoms.Stack.Type.Column,
    sm: _atoms.Stack.Type.Column,
    md: _atoms.Stack.Type.Column,
    lg: _atoms.Stack.Type.Row
  }, /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "personalize-preview ".concat(showContentInMobileClassName)
  }, /*#__PURE__*/_react.default.createElement(_PersonalizeControlsHeader.PersonalizeControlsHeader, {
    title: "Tag your moment",
    className: "mobile",
    onBackClick: handlePreviousStepClick,
    onCloseClick: handleCloseClick,
    showBackButton: showPreviousButton
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "moment-editor-video-container spotlight"
  }, /*#__PURE__*/_react.default.createElement(VideoPreview, {
    moment: massagedFullGameMoment,
    containerRef: videoPlayerContainerRef,
    updates: updates,
    duration: momentDuration
  }))), /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "personalize-controls",
    alignItems: "center",
    height: "100%"
  }, /*#__PURE__*/_react.default.createElement(_PersonalizeControlsHeader.PersonalizeControlsHeader, {
    title: "Tag your moment",
    className: "desktop",
    onBackClick: handlePreviousStepClick,
    onCloseClick: handleCloseClick,
    showBackButton: showPreviousButton
  }), /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "controls-content",
    justifyContent: "flex-start"
  }, tagsType === "trace" && /*#__PURE__*/_react.default.createElement(_TraceTagsToggler.TraceTagsToggler, {
    sportType: sport,
    tags: tags,
    onTag: function onTag(tagName) {
      dispatch({
        type: "toggle",
        name: tagName
      });
    }
  }), (tagsType === "game" || tagsType === "edit") && /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    padding: "8 6",
    className: "GameTagsToggler"
  }, /*#__PURE__*/_react.default.createElement(_TagEditor.TagEditor, {
    key: "".concat(tags.map(function (t) {
      return "".concat(t.category, "-").concat(t.name, "-").concat(t.selected);
    }).join("|")),
    tags: tags,
    onTag: function onTag(tagName) {
      dispatch({
        type: "toggle",
        name: tagName
      });
    }
  }))), /*#__PURE__*/_react.default.createElement(_PersonalizeControlsFooter.PersonalizeControlsFooter, {
    buttonTitle: buttonTitle,
    onButtonClick: handleNextStepClick
  }))));
};

exports.StepTags = StepTags;

var VideoPreview = function VideoPreview(_ref2) {
  var containerRef = _ref2.containerRef,
      moment = _ref2.moment,
      updates = _ref2.updates,
      duration = _ref2.duration;

  // Video info
  var _useVideoInfo = (0, _VideoPlayer.useVideoInfo)(containerRef),
      currentTime = _useVideoInfo.currentTime;

  var startAt = updates.startAtRelative;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_VideoPlayer.VideoPlayer, {
    containerRef: containerRef,
    noMulticam: true,
    spotlight: true,
    moment: moment,
    startAt: updates.startAtRelative,
    stopAt: updates.stopAtRelative,
    muted: true,
    loop: true
  }), /*#__PURE__*/_react.default.createElement(_molecules.ProgressBar, {
    className: "moment-preview-progress-bar",
    background: "transparent-color",
    value: currentTime - startAt,
    total: duration,
    width: "100%",
    opacity: 1
  }));
};

StepTags.defaultProps = {
  showContentInMobile: true,
  newOrEditedMoment: null,
  onPreviousStep: null,
  tagsType: "trace",
  game: null
};